module.exports = __webpack_public_path__ + "img/tips.14c300b0.png";